<template>
  <aside class="AtlasDatumExplorer">
    <div class="AtlasDatumExplorer-content" v-html="sanitize(content)"></div>
  </aside>
</template>

<script>
import sanitize from 'sanitize-html';
import tokenizer from '@datalas/tokenizer';
import { mapGetters } from 'vuex';

export default {
  props: {
    breakdownId: {
      type: String,
      required: true,
    },
    datum: {
      type: Object,
    },
  },

  computed: {
    ...mapGetters('breakdown', [
      'dataByBreakdownId',
      'tokenContextByBreakdownId',
      'breakdownById',
    ]),

    breakdown() {
      return this.breakdownById(this.breakdownId);
    },
    data() {
      return this.dataByBreakdownId(this.breakdownId);
    },
    tokenContext() {
      return this.tokenContextByBreakdownId(this.breakdownId);
    },

    tokenize() {
      const { data, tokenContext, breakdown, datum } = this;
      const { statements, tokens } = breakdown;

      return tokenizer(data, tokenContext, statements, tokens, datum);
    },

    content() {
      const {
        datum: { message },
      } = this;

      return message || this.tokenize(this.breakdown.statements.MOUSEOVER);
    },
  },

  methods: {
    sanitize,
  },
};
</script>

<style lang="scss">
.AtlasDatumExplorer {
  @include elevation;
  min-width: 226px;
  max-width: 400px;
  padding: $gutter;
  background-color: color(bg);
  font-size: 20px;
  line-height: 26px;
  pointer-events: none;

  h3,
  p {
    margin: 0;
    font-size: inherit;
    line-height: inherit;
  }

  h3 {
    font-weight: bold;
  }
}
</style>
